<!-- 企业咨询 -->
<template>
  <div class="consulting_service" v-loading="loadiong">
    <div class="conent">
      <div class="conent_title">{{isService
        ? '企业咨询'
        : '招商加盟'}}</div>
       <el-button class="onservice" type="primary" @click="onservice">{{ isTitle }}</el-button>
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="company_name" label="公司名"></el-table-column>
        <el-table-column prop="place_data" label="公司地址"></el-table-column>
        <el-table-column prop="person_name" label="姓名"></el-table-column>
        <el-table-column prop="contact_way" label="手机号"></el-table-column>
        <el-table-column prop="contact_way" label="开通账号">
          <template slot-scope="scope">{{
            scope.row.is_exist_username ? "是" : "否"
          }}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
        :current-page.sync="currentPage"
          background
          layout="prev, pager, next"
          :page-size="15"
          :total="total"
          hide-on-single-page
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      currentPage:1,
      tableData: [],
      total: 0,
      loadiong: true,
      isService: false,
      isTitle: "企业咨询",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onservice() {
      this.currentPage = 1;
      let type = "";
      this.isService = !this.isService;
      this.isService
        ? (this.isTitle = "招商加盟")
        : (this.isTitle = "企业咨询");
      this.isService ? (type = "0") : (type = "1");
      this.init(0, type);
    },
    tableRowClassName({ row, index }) {
      // console.log(row);
      if (row.is_exist_username) {
        return "xuanzhong";
      }
      return "weixuanze";
    },
    pageChange(page) {
      console.log(this.currentPage)
      console.log(page)
      var type = "";
      this.isService ? (type = "0") : (type = "1");
      this.init(page - 1, type);
    },
    init(page, type) {
      this.loadiong = true
      require("post", "/hr24_index_data/v1/consult_list/", { page, type }).then(
        (res) => {
          if (!res.code) {
            this.tableData = res.data.consult_data;
            this.total = res.data.consult_count;
            this.loadiong = false;
          }
          // console.log(res);
          this.loadiong = false
        }
      );
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init(0, 1);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.consulting_service {
  width: calc(100% - 190px);
  min-height: 80vh;
  background: #fff;
  margin-top: 68px;
  margin-left: 190px;
}
.conent {
  width: 90%;
  margin: auto;
  padding: 60px 0;
}
.page {
  padding: 20px 0;
  text-align: center;
}
.el-table >>> .xuanzhong {
  background: #f9ebeb;
}
.el-table >>> .weixuanze {
  background: #f1f9eb;
}
.onservice{
  margin-bottom: 20px;
  float: right;
}
.conent_title{
  float: left;
  font-size: 24px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/user_management/consulting_service.vue